import { IconButton, Typography } from "@material-ui/core"
import NextLink from "common/bit/NextLink"
import { useAppDispatch, useTypedSelector } from "store"
import styled, { css } from "styled-components"
import useInStock from "./useInStock"
import { setHideOutOfStockBanner } from "./wizardSlice"

const StyledBanner = styled.div<{ $isSummery: boolean; $addPadding: boolean }>`
  position: absolute;
  left: ${(p) => (!p.$addPadding ? "0" : "24px")};
  right: ${(p) => (!p.$addPadding ? "0" : "24px")};
  ${(p) => (p.$isSummery ? "top: 0" : "bottom:calc(100% + 24px)")};
  background-color: ${(p) => p.theme.colors.mazdaRed};
  display: flex;
  /* padding: 0 8px 0 0; */
  align-items: center;
  z-index: 1300;
  border-radius: 3px;

  ${(p) => p.theme.breakpoints.down("sm")} {
    left: 0;
    right: 0;
    padding: 3px 0 3px 0;
    z-index: 1100;
    bottom: calc(100% + 10px);
    ${(p) =>
      p.$isSummery &&
      css`
        position: relative;
        top: 0;
        bottom: 0;
        left: 0;
        border-radius: 0;
        left: 0;
        right: 0;
      `}
  }
  ${(p) =>
    p.$isSummery &&
    css`
      position: relative;
      top: 0;
      left: 0;
      border-radius: 0;
      left: 0;
      right: 0;
    `}
`
const StyledText = styled(Typography)`
  color: ${(p) => p.theme.colors.white};
  font-size: 12px;
  line-height: 1.3;
  font-family: ${(p) => p.theme.typography.fontFamily};
  padding: 8px 16px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    padding: 4px 8px;
  }
  letter-spacing: initial;
`

const StyledIconButton = styled(IconButton)`
  margin-right: auto;
  padding: 6px 8px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    align-self: flex-start;
  }
`

const StyledLink = styled(NextLink)`
  color: ${(p) => p.theme.colors.white};
  text-decoration: underline;
  font-weight: 700;
`

type Props = {
  isSummery?: boolean
  isColors?: boolean
}

const OutOfStockBanner = ({ isSummery = false, isColors }: Props) => {
  const { hideOutOfStockBanner, showOnlyStock } = useTypedSelector(
    (state) => state.wizard
  )
  const inStock = useInStock()
  const dispatch = useAppDispatch()

  if (inStock || showOnlyStock || hideOutOfStockBanner) return null
  return (
    <StyledBanner $isSummery={isSummery} $addPadding={isColors}>
      <StyledText>
        חלק מהבחירות שלך לא זמינות כרגע באתר, רוצה שנעזור לך למצוא את הרכב
        המתאים עבורך?{" "}
        <StyledLink href="/contact-us?subject=קניית רכב">
          להשארת פרטים
        </StyledLink>
      </StyledText>
      {!isSummery && (
        <StyledIconButton
          onClick={() => dispatch(setHideOutOfStockBanner(true))}
        >
          <img src="/icons/exitMenu.svg" alt="סגירת ההודעה" />
        </StyledIconButton>
      )}
    </StyledBanner>
  )
}

export default OutOfStockBanner
